import {
  CREATE_PROGRAM_DETAILS_FAILED,
  CREATE_PROGRAM_DETAILS_SUCCESS,
  CREATE_PROGRAM_COMMITMENTS_FAILED,
  CREATE_PROGRAM_COMMITMENTS_SUCCESS,
  UPLOAD_SANDBOX_FAILED,
  UPLOAD_SANDBOX_SUCCESS,
  GET_PROGRAM_PUBLISH_SUCCESS,
  GET_PROGRAM_PUBLISH_FAILED,
  UPDATE_PROGRAM_STATUS_FAILED,
  UPDATE_PROGRAM_STATUS_SUCCESS,
  UPDATE_PROGRAM_DETAILS_SUCCESS,
  UPDATE_PROGRAM_DETAILS_FAILED,
  UPDATE_PROGRAM_DAY_DETAILS_FAILED,
  UPDATE_PROGRAM_DAY_DETAILS_SUCCESS,
  SEARCH_PROGRAM_SUCCESS,
  SEARCH_PROGRAM_FAILED,
  UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS,
  UPDATE_PROGRAM_PUBLISH_STATUS_FAILED,
  REMOVE_PROGRAM_SUCCESS,
  REMOVE_PROGRAM_FAILED,
  REMOVE_COMMITMENT_SUCCESS,
  REMOVE_COMMITMENT_FAILED,
  GET_EXPLORE_CONTENT_SUCCESS,
  GET_EXPLORE_CONTENT_FAILED,
  GET_PROGRAM_CATEGORY_SUCCESS,
  GET_PROGRAM_CATEGORY_FAILED,

} from "../Actions/ProgramAction";
import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";
import decryptResponse from "../../Components/Decrypt";

export function* createProgramSaga(action) {
  try {
    const response = yield call(axios.post, `/create-program`, action.payload);
    const { data, message } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: CREATE_PROGRAM_DETAILS_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: CREATE_PROGRAM_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* creatCommitmentsSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/create-commitments`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: CREATE_PROGRAM_COMMITMENTS_SUCCESS,
      payload: decryptData,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: CREATE_PROGRAM_COMMITMENTS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* uploadSandBoxSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/upload-to-sandbox`,
      action.payload
    );
    const { status, success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: UPLOAD_SANDBOX_SUCCESS,
      payload: { decryptData, success },
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: status },
    });
  } catch (e) {
    yield put({ type: UPLOAD_SANDBOX_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getProgramPublishSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-program-and-commitment-details/${action.payload}`
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: GET_PROGRAM_PUBLISH_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_PROGRAM_PUBLISH_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* updateProgramStatusSaga(action) {
  try {
    const response = yield call(
      axios.patch,
      `/change-program-status`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: UPDATE_PROGRAM_STATUS_SUCCESS,
      payload: decryptData,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: UPDATE_PROGRAM_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* updateProgramDetailsSaga(action) {
  try {
    const response = yield call(axios.patch, `/edit-program`, action.payload);
    const { status, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: UPDATE_PROGRAM_DETAILS_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: status },
    });
  } catch (e) {
    yield put({ type: UPDATE_PROGRAM_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* updateProgramDayDetailsSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/update-commitment-details`,
      action.payload
    );
    const { status, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: UPDATE_PROGRAM_DAY_DETAILS_SUCCESS,
      payload: decryptData,
    });

    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: status },
    });
  } catch (e) {
    yield put({ type: UPDATE_PROGRAM_DAY_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* programSearchSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-search-program-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: SEARCH_PROGRAM_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: SEARCH_PROGRAM_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* RemoveProgramSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-program/${action?.payload?.Id}`
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: REMOVE_PROGRAM_SUCCESS, payload: action?.payload?.Id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_PROGRAM_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* updateProgramPublishStatusSaga(action) {
  try {
    const response = yield call(
      axios.patch,
      `/change-program-publish-draft-status`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: UPDATE_PROGRAM_PUBLISH_STATUS_SUCCESS,
      payload: decryptData,
    });
    if (
      message === "Program move to publish successfully!" ||
      message === "Program move to sandbox  successfully!"
    ) {
      yield put({
        type: TOAST_SHOW,
        payload: { message: message, severity: "success" },
      });
    }
  } catch (e) {
    yield put({ type: UPDATE_PROGRAM_PUBLISH_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* RemoveCommitmentDetailsSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-commitment-details/${action?.payload?.cd_id}`
    );

    const { success, data, message, errors } = response?.data;
    yield put({
      type: REMOVE_COMMITMENT_SUCCESS,
      payload: action?.payload,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_COMMITMENT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getExploreContentSaga(action) {
  try {
    const response = yield call(axios.get, `/get-explore-title-list`);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: GET_EXPLORE_CONTENT_SUCCESS,
      payload: decryptData.explore_list,
    });
  } catch (e) {
    yield put({ type: GET_EXPLORE_CONTENT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getProgramCategorySaga(action) {
  try {
    const response = yield call(axios.get, `/get-categories`);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: GET_PROGRAM_CATEGORY_SUCCESS,
      payload: decryptData.category_list,
    });
  } catch (e) {
    yield put({ type: GET_PROGRAM_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

